import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import SuccessAlertModal from "../../Modals/successAlertModal";
import ConfirmAlertModal from "../../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import { isNumberwithdashdot } from "../../../functions/validations";
import { showSuccess, showWarning } from "../../utility/ui/notifications/Toaster";
import ButtonModal from "../../Modals/buttonModal";
import { updateTrainingRecord } from "../../../Services/trainingRecord-service";

const AddEditAttendanceDetails = (props) => {
  let action = props.action;
  console.log("props",props)
  let formName = "Attendance Details";
  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const history = useNavigate();
  const [TrainingObj, setTrainingObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_marks: "",
        wld_percentage: "",
        wld_score: "",
        wld_attendance: "",
      }
  );

  const [error, setError] = useState({
    wld_marks: {},
    wld_percentage: {},
    wld_score: {},
    wld_attendance: {},
  });
  const modalOnClick = () => {
    history("/", { state: { data: "setTrainingObj" } });
};

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };
  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTrainingObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState
    }));
  };



  const handleAttendanceChange = (e) => {
    const { name, value } = e.target;

    if (e.target.value === 'Absent') {
      setTrainingObj((prevState) => ({
        ...prevState,
        wld_attendance: e.target.value,
        wld_score: '',
        wld_marks: '',
        wld_percentage: ''
      }));
    }
    else {
      setTrainingObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const resetForm = () => {
    setTrainingObj((prevState) => ({
      ...prevState,
      wld_marks: "",
      wld_percentage: "",
      wld_score: "",
      wld_attendance: "",
    }));

    setError((prevState) => ({
      ...prevState,
      wld_marks: {},
      wld_percentage: {},
      wld_score: {},
      wld_attendance: {},
      // SK: {},
    }));
  };

  const validateAttendance = () => {
    const newErrors = {};
    let isError = false;

    if (!TrainingObj.wld_attendance) {
      isError = true;
      newErrors.wld_attendance = {
        status: true,
        message: "Attendance is required.",
      };
    }

    if (TrainingObj.wld_attendance === "Present") {
      if (!TrainingObj.wld_marks?.trim()) {
        isError = true;
        newErrors.wld_marks = {
          status: true,
          message: "Marks is required.",
        };
      }

      if (!TrainingObj.wld_score?.trim()) {
        isError = true;
        newErrors.wld_score = {
          status: true,
          message: "Score is required.",
        };
      }

      // Validate score is not greater than marks
      if (TrainingObj.wld_score && TrainingObj.wld_marks &&
        parseFloat(TrainingObj.wld_score) > parseFloat(TrainingObj.wld_marks)) {
        isError = true;
        newErrors.wld_score = {
          status: true,
          message: "Score cannot be greater than total marks.",
        };
      }
    }

    setError((prevState) => ({
      ...prevState,
      ...newErrors,
    }));

    return isError;
  };

  

  const handleAdd = async () => {
  try {
    // Safely derive percentage without mutating TrainingObj directly
    const score = Number(TrainingObj?.wld_score);
    const marks = Number(TrainingObj?.wld_marks);

    const computedPercentage =
      TrainingObj?.wld_attendance === 'Present' &&
      Number.isFinite(score) &&
      Number.isFinite(marks) &&
      marks > 0
        ? ((score / marks) * 100).toFixed(2)
        : undefined;

    const payload = {
      ...TrainingObj,
      ...(computedPercentage !== undefined ? { wld_percentage: computedPercentage } : {})
    };

    // Since this is always Edit, always call update
    const result = await updateTrainingRecord(payload);

    // If your API can *rarely* send Duplicate on update, keep this guard
    if (result?.message === "Duplicate") {
      showWarning("Duplicate record found");
    } else {
      showSuccess("Selected attendance detail has been updated successfully");
    }

    props.setReload(!props.reload);
    setShowForm(false);
    props.onHide();
  } catch (error) {
    console.error("Error updating attendance details:", error);
    showWarning("Failed to update attendance details");
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    let val = validateAttendance();
    if (!val) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Attendance detail successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} Training Detail</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2 pb-2">
              <Row className="gx-3" style={{ marginBottom: "2rem" }}>
                <Col md={4}>
                  <div className="m-input" style={{ width: 400 }}>
                    <span>Attendance</span>
                    <div className="d-flex mb-2">
                      <div>
                        <input
                          type="radio"
                          name="wld_attendance"
                          value='Present'
                          checked={TrainingObj.wld_attendance === 'Present'}
                          onChange={handleAttendanceChange}
                          style={{
                            fontSize: 12,
                            border: 20,
                            height: 10,
                          }}
                        />
                        <span style={{ fontSize: 14 }}>
                          Present
                        </span>
                      </div>
                      <div style={{ paddingLeft: "30px" }}>
                        <input
                          type="radio"
                          name="wld_attendance"
                          value='Absent'
                          checked={TrainingObj.wld_attendance === 'Absent'}
                          onChange={handleAttendanceChange}
                          style={{
                            fontSize: 12,
                            border: 20,
                            height: 10,
                          }}
                        />
                        <span style={{ fontSize: 14 }}>
                          Absent
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_score"
                        name="wld_score"
                        type="text"
                        maxLength="50"
                        disabled={TrainingObj.wld_attendance === 'Absent'}
                        className={`asterisk ${error.wld_score.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={TrainingObj.wld_score}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumberwithdashdot(
                            e.target.value
                          );
                          setError((prevState) => ({
                            ...prevState,
                            wld_score: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_score">
                        Score
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_score.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "10px", fontSize: "11px" }}>
                          {error.wld_score.message}
                        </span>{" "}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_marks"
                        name="wld_marks"
                        placeholder=" "
                        maxLength="5"
                        disabled={TrainingObj.wld_attendance === 'Absent'}
                        className={
                          error.wld_marks.status
                            ? " g-input placeHolderInput inputText text-field-with-error allow"
                            : "g-input placeHolderInput inputText allow"
                        }
                        value={TrainingObj.wld_marks}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumberwithdashdot(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_marks: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_marks">
                        Total Marks{" "}
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_marks.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "20px", fontSize: "11px" }}>
                          {error.wld_marks.message}
                        </span>{" "}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_percentage"
                        name="wld_percentage"
                        type="text"
                        maxLength="50"
                        disabled={TrainingObj.wld_attendance === 'Absent'}
                        className={`asterisk ${error.wld_percentage.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={TrainingObj.wld_attendance === 'Present' ? ((TrainingObj.wld_score / TrainingObj.wld_marks) * 100).toFixed(2) : " "}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isNumberwithdashdot(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_percentage: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_percentage">
                        Percentage
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_percentage.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "10px", fontSize: "11px" }}>
                          {error.wld_percentage.message}
                        </span>{" "}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>

          <Row>
            <ButtonModal action={action} training={"training"} resetForm={resetForm}></ButtonModal>
          </Row>

          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>

    </>
  );
};

export default AddEditAttendanceDetails;
